// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ProcessRefundsBatchResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /payroll/process_refunds_batch
 *
 * Dados shape: Batch processing result with accepted, declined, and errors arrays.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_ProcessRefundsBatchResponseDados {
accepted: unknown[]
declined: unknown[]
errors: unknown[]
}

export type Payroll_ProcessRefundsBatchResponse = ApiResponse<Payroll_ProcessRefundsBatchResponseDados>;

registerResponseContract('Payroll_ProcessRefundsBatchResponse', {
  accepted: { type: 'array',   required: true },
  declined: { type: 'array',   required: true },
  errors:   { type: 'array',   required: true },
})
